// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__0Ejga","title":"styles_title__iqRai","sub_title":"styles_sub_title__5XK6X"};